import type { ReactNode } from 'react';
import { cn } from '../../utils/helpers';

interface TableProps {
  children: ReactNode;
  className?: string;
}

export function Table({ children, className }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table className={cn('w-full text-left border-collapse', className)}>
        {children}
      </table>
    </div>
  );
}

interface TableHeadProps {
  children: ReactNode;
  className?: string;
}

export function TableHead({ children, className }: TableHeadProps) {
  return (
    <thead className={cn('border-b border-[#2a2a3a]', className)}>
      {children}
    </thead>
  );
}

interface TableBodyProps {
  children: ReactNode;
  className?: string;
}

export function TableBody({ children, className }: TableBodyProps) {
  return <tbody className={cn('', className)}>{children}</tbody>;
}

interface TableRowProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  hover?: boolean;
}

export function TableRow({ children, className, onClick, hover = false }: TableRowProps) {
  return (
    <tr
      onClick={onClick}
      className={cn(
        'border-b border-[#2a2a3a] last:border-b-0',
        hover && 'table-row-hover cursor-pointer hover:bg-[#22222e]',
        className
      )}
    >
      {children}
    </tr>
  );
}

interface TableHeaderProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  sortable?: boolean;
}

export function TableHeader({ children, className, onClick, sortable = false }: TableHeaderProps) {
  return (
    <th
      onClick={onClick}
      className={cn(
        'py-3 px-4 text-xs font-medium text-[#94a3b8] uppercase tracking-wider',
        sortable && 'cursor-pointer select-none hover:text-[#f1f5f9] transition-colors',
        className
      )}
    >
      {children}
    </th>
  );
}

interface TableCellProps {
  children: ReactNode;
  className?: string;
}

export function TableCell({ children, className }: TableCellProps) {
  return (
    <td className={cn('py-3 px-4 text-sm text-[#f8fafc]', className)}>
      {children}
    </td>
  );
}
